// Layout-only route for the /knowledges segment. The actual list page lives
// in `knowledges.index.tsx` so child detail/edit routes (knowledges.$id*)
// can render inside this Outlet — without it, navigating to /knowledges/<id>
// silently keeps the list visible because the child has no rendering slot.
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { requireFeatureEnabled } from "@/features/features";

export const Route = createFileRoute("/_admin/knowledges")({
  beforeLoad: () => requireFeatureEnabled("knowledge_base"),
  component: KnowledgesLayout,
});

function KnowledgesLayout() {
  return <Outlet />;
}
